// Campi professionista dell'assistito nella scheda pratica: mappatura campo -> anagrafica.
export const PRO_FIELDS = [
  { key: "assistito_liquidatore", atype: "liquidatori", label: "Liquidatore" },
  { key: "assistito_perito_compagnia", atype: "periti", label: "Perito Compagnia" },
  { key: "assistito_accertatore", atype: "accertatori", label: "Accertatore" },
  { key: "assistito_perito_parte", atype: "periti", label: "Perito di Parte" },
  { key: "assistito_medico_legale", atype: "medici_legali", label: "Medico Legale di Parte" },
  { key: "assistito_riparatore", atype: "carrozzieri", label: "Riparatore" },
  { key: "assistito_legale", atype: "avvocati", label: "Legale Incaricato" },
];

// Professionisti mostrati per il conducente attivato come secondo cliente.
export const COND_PRO_FIELDS = [
  PRO_FIELDS.find((f) => f.key === "assistito_medico_legale"),
  { key: "assistito_medico_legale_compagnia", atype: "medici_legali", label: "Medico Legale della Compagnia" },
  PRO_FIELDS.find((f) => f.key === "assistito_legale"),
];

export const PRO_ATYPES = [...new Set(PRO_FIELDS.map((f) => f.atype))];
